import { render, staticRenderFns } from "./WarningModalBuy.vue?vue&type=template&id=56b25290"
import script from "./WarningModalBuy.vue?vue&type=script&lang=js"
export * from "./WarningModalBuy.vue?vue&type=script&lang=js"
import style0 from "./WarningModalBuy.vue?vue&type=style&index=0&id=56b25290&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports